import { LanguageLevelSchema } from 'schemas/language.schema'
import { z } from 'zod'

const cVStepLanguagesSchema = z.object({
  languages: LanguageLevelSchema.array().min(1, 'custom.select1Language')
})

export default cVStepLanguagesSchema
